import { render, staticRenderFns } from "./InstantCreditStatus.vue?vue&type=template&id=628835d2"
import script from "./InstantCreditStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantCreditStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports